import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";
import { editGoogleAccount, getGoogleAccount } from "./GoogleAccountService";

function GoogleAccountDetailed({
  googleAccount,
  setGoogleAccount,
  geoKeys,
  reCaptchaKeys,
}) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectedCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [reCaptcha, setReCaptcha] = useState({});
  const [geolocation, setGeolocation] = useState(false);
  const [geoKey, setGeoKey] = useState({});

  const checkEntered = () => {
    if (
      reCaptcha.id === null ||
      reCaptcha.id === undefined ||
      reCaptcha.id === ""
    ) {
      return false;
    }
    return true;
  };

  function saveGoogleAccount() {
    if (!checkEntered()) {
      setInputError(true);
      return;
    }

    let data = {
      ClientId: selectedCareersClient.id,
      RecaptchaKeyId: reCaptcha.id,
      PlacesKeyId: geoKey.id,
      HasGooglePlaces: geolocation,
    };

    callAPI(
      editGoogleAccount(data),
      "Google Account Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getGoogleAccount(selectedCareersClient.id).then((response) => {
        setGoogleAccount(response);
      });
    });
  }

  useEffect(() => {
    setReCaptcha({});
    setGeoKey({});
    reCaptchaKeys.forEach((key) => {
      if (key.id === googleAccount.recaptchaKeyId) {
        setReCaptcha(key);
      }
    });
    geoKeys.forEach((key) => {
      if (key.id === googleAccount.placesKeyId) {
        setGeoKey(key);
      }
    });
    setGeolocation(googleAccount.hasGooglePlaces);
  }, [googleAccount, geoKeys, reCaptchaKeys]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid xs={12} sm={12} item>
                  <DropdownComponent
                    currValue={reCaptcha}
                    items={reCaptchaKeys}
                    property="name"
                    title="reCaptcha Key"
                    handleChange={(value) => setReCaptcha(value)}
                    error={inputError}
                  />
                  {inputError && reCaptcha.id === undefined && (
                    <FormHelperText className={classes.error}>
                      reCaptchaKey Required
                    </FormHelperText>
                  )}
                </Grid>
                <Grid xs={12} sm={12} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={geolocation}
                        onChange={() => setGeolocation(!geolocation)}
                      />
                    }
                    label="Use Google Geolocation"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <DropdownComponent
                    currValue={geoKey}
                    items={geoKeys}
                    property="name"
                    title="Places Geolocation Key"
                    handleChange={(value) => setGeoKey(value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} container justifyContent="flex-end">
                  <Button
                    style={{ marginTop: "20px", marginRight: "8px" }}
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => saveGoogleAccount()}
                  >
                    Save Information
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </>
  );
}

export default GoogleAccountDetailed;
